module.exports = __webpack_public_path__ + "b359fb198ebf8bfa84a234407a261ed4.woff";